import { useApolloClient } from '@apollo/client';
import Formsy from 'formsy-react';
import React, { useEffect, useMemo, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { executeGraphQLMutation, executeGraphQLQuery } from '../../../common/executeGraphQLQuery';
import { computationValueLength } from '../../../common/helper';
import {
    ADVANCE_DEALER_PAID,
    CHECK_ASSIGN_USER,
    IS_USER_ACCESS_PAGE,
    MAX_ADVANCE_LOAN_VALUE,
    PAYMENT_TYPES,
    ROUNDOFF_TO_MAX_LIMIT,
    SUB_STATUS_CODES,
    TENURE_IN_MONTH,
    TRANCHE_STATUS,
    TRUCK_IDS,
    UPLOAD_TYPE,
    calculatePercentageValue,
    isRegeneratedFieldNeedToActive,
    isRegeneratedMainDealerFieldsNeedToActive
} from '../../../config/constants';
import crypto from '../../../config/crypto';
import GeneralService from '../../../services/generalService';
import { COMPUTATION_MASTER_DATA, SAVE_COMPUTATION_DETAILS, UPDATE_LEAD_STATUS } from '../../../services/leads.gql';
import { getLoanDetail, getMasterDataMMVComputation } from '../../../store/action/allAction';
import resubmitIcn from "../../../webroot/images/resubmit.svg";
import Modal from '../../elements/Modal';
import LeadRemarkHistory from '../../lead-list/LeadRemarkHistory';
import DocumentGallery from '../DocumentGallery';
import FormFields from "../formFields/computation.json";
import AdvanceDealerPayout from './components/AdvanceDealerPayout';
import BasicDetails from './components/BasicDetails';
import CarmudiPaymentToDealerDetails from './components/CarmudiPaymentToDealerDetails';
import ComputationDetails from './components/ComputationDetails';
import ExtraDetails from './components/ExtraDetails';
import FinalLoanDetails from './components/FinalLoanDetails';
import PassThroughDetails from './components/PassThroughDetails';
import PaymentFromFinancierDetails from './components/PaymentFromFinancierDetails';
import IfSettlementBox from './components/IFsettlementBox';
import UploadDocuments from './components/UploadDocuments';
import { registerComputationFormsyValidationRules } from './computation.validator';
import {MARKET_INCENTIVE} from "../../../services/financer.gql"
registerComputationFormsyValidationRules();

const FORM_FIELDS = FormFields["BASIC_DETAILS"];
const ADVANCE_DEALER_PAYOUT = FormFields["ADVANCE_DEALER_PAYOUT"];

let PAID_THROUGH_OPTIONS = [
    {value: "loan_proceeds", label: "Loan Proceeds"},
    {value: "dealer_incentive", label: "Dealer Incentive"}
]



const Computation = (props) => {
    const user_information = useSelector((state) => state.user.user_information);
    const UserInfo = JSON.parse(user_information);
    const [selectedTab, setSelectedTab] = useState("first");
    const [computationDetails, setComputationDetails] = useState({});
    const [computationMasterDetails, setComputationMasterDetails] = useState([]);
    const [ongoingPromo, setOngoingPromo] = useState({});
    const [loanAmountPass, setLoanAmountpass] = useState({});
    const [diAmountPass, setDiAmountpass] = useState({});
    const [advanceDiPaid, setAdvanceDiPaid] = useState({});
    const [vatInput, setVatInput] = useState({});
    const [allowSubmit, setAllowSubmit] = useState(false);
    const [computationSubmit, setComputationSubmit] = useState(false);
    const [allOptions, setAllOptions] = useState({});
    const [ViewTimeLine, setViewTimeLine] = useState(false);
    const [showremarkform, setShowremarkform] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [comment, setComment] = useState("");
    const [vehicleType, setVehicleType] = useState(0);
    const [adpPerValue, setAdpPerValue] = useState(false);
    const [computationDocuments, setComputationDocuments] = useState([]);
    const [IsVatBackInvolved,setIsVatBackInvolved]=useState({is_vat_back_involved: "No"});
    const [isVatBackRadiosFilled, setIsVatBackRadiosFilled] = useState(false);
    const [FinssoInput, setFinssoInput] = useState({});
    const { masterdata, lead, remarksHistory } = useSelector(({ masterdata, lead }) => ({
        masterdata,
        lead,
        remarksHistory: lead.remarksHistory || []
    }));
    let params = useParams();
    let lead_id = crypto.decode(params.lead_id);
    let navigate = useNavigate();
    const client = useApolloClient();
    const dispatch = useDispatch();
    const getContext = useOutletContext();
    const documentCategoryList = getContext.docList || [];
    const [financierConfig, setFinancierConfig] = useState({
        marketplaceIncentive: null,
        wht: null,
    });
    const [miEffectiveDate, setMiEffectiveDate] = useState(null);
    const [miConfigType, setMiConfigType] = useState(null);
    let accessCondition = !IS_USER_ACCESS_PAGE("computation", props.current_page)?.is_edit_access;
    if (!accessCondition) {
        accessCondition = CHECK_ASSIGN_USER(lead?.leadDetail?.assign_to);
    }
    let financierIdArr = lead?.leadDetail?.financier?.filter(data => data.is_proceed === 'yes');
    let financierId = financierIdArr?.[0]?.financier_id;
    let quoteData = lead?.leadDetail?.quote_data?.find(data => data.financier_id === financierId) || {};
    
    const getMasterDataOptions = async () => {
        let options = masterdata ? { ...masterdata.data, ...masterdata.masterdatammvcomp } : {};
        // let optionsmmv = masterdata ? {...masterdata.masterdatammv} : {};
        //console.log(options.model[0],"ooooooooooooooooooo")
        options["brand"] = options.make?.map(make => ({ value: make.id, label: make.make }));

        options["model"] = options.model?.map(model => ({ value: model.id, label: model.m, mk_id: model.mk_id }));

        options["variant"] = options.version?.map(version => ({ value: version.vn_id, label: version.vn, mk_id: version.mk_id, md_id: version.md_id }));
        // options['vehicle_type']=options.vehicle_type;
        
        options["yearofmanufacturing"] = options.make_year;
        options["tenure"] = TENURE_IN_MONTH['0'];
        options.brand?.push({ value: 0, label: 'Other' });
        options.model?.push({ value: 0, label: 'Other' });
        options.variant?.push({ value: 0, label: 'Other' });
        options.paid_through = PAID_THROUGH_OPTIONS;
        // options["model"] = !lead?.leadDetail?.lead_computation_details ? options["model"]?.filter(md => md.mk_id == lead?.leadDetail?.lead_details?.make_id) : lead?.leadDetail?.lead_computation_details?.make_id === 9997 ? options["model"]?.filter(md => 9997 == lead?.leadDetail?.lead_computation_details?.make_id) : options["model"]?.filter(md => md.mk_id == lead?.leadDetail?.lead_computation_details?.make_id) ;
        // options["variant"] = !lead?.leadDetail?.lead_computation_details ?  options["variant"]?.filter(v => v.md_id === lead?.leadDetail?.lead_details?.model_id): lead?.leadDetail?.lead_computation_details?.model_id === 9998 ? options["variant"]?.filter(v => 9998 === lead?.leadDetail?.lead_computation_details?.model_id) : options["variant"]?.filter(v => v.md_id === lead?.leadDetail?.lead_computation_details?.model_id);

        setAllOptions(prev => ({ ...prev, ...options }));
    };
    const showConfirmation = () => {
        setConfirmationModal(true);
        document.body.classList.add("overflow-hidden");
    };
  
    const hideConfirmation = () => {
        setConfirmationModal(false);
        document.body.classList.remove("overflow-hidden");
    };

    const handleInputChange = event => {
        if (event.target.id) {
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.id]: event.target.value
            }));
        }
    };

    useEffect(() => {
        if (props.current_page === 'computation_regenerated' && [SUB_STATUS_CODES.COMPUTATION_RESET].includes(lead?.leadDetail?.oti_sub_status_id)) {
            document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = (computationDetails?.ongoing_promo === '0' && true) || false;
        }
    }, [computationDetails?.ongoing_promo]);

    useEffect(() => {
        if (props.current_page === 'computation_regenerated' && [SUB_STATUS_CODES.COMPUTATION_RESET].includes(lead?.leadDetail?.oti_sub_status_id)) {
            if (computationDetails?.vat_input === 'exclusive') {
                document.getElementById('exclusiveper').readOnly = false;
                document.getElementById('inclusiveper').readOnly = true;
            }
            else if (computationDetails?.vat_input === 'inclusive') {
                document.getElementById('inclusiveper').readOnly = false;
                document.getElementById('exclusiveper').readOnly = true;
            }
        }
    }, [computationDetails?.vat_input]);

    const handleRadioChange = event => {
        const { name, value } = event.target;
        if (event.target.name === 'ongoing_promo' && event.target.value === '1') {
            document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = false;
        } else if (event.target.name === 'ongoing_promo' && event.target.value === '0') {
            document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = true;
        }

        if (event.target.name === 'ongoing_promo') {
            setOngoingPromo({
                [event.target.name]: event.target.id
            });
        } else if (event.target.name === 'loan_amount_pass_through') {
            event.target.value === 'yes' ? setComputationDetails((prev) => ({ ...prev, loan_amount_paid: computationDetails?.loan_value, total_payment_from_financier_to_carmudi: computationDetails?.di_amount_from_financier_to_carmudi_net_amount, final_loan_value: 0 })) : setComputationDetails((prev) => ({ ...prev, loan_amount_paid: 0, total_payment_from_financier_to_carmudi: computationDetails?.loan_value + computationDetails?.di_amount_from_financier_to_carmudi_net_amount, final_loan_value: computationDetails?.loan_value }));
            setLoanAmountpass({
                [event.target.name]: event.target.id
            });
        } else if (event.target.name === 'di_amount_pass_through') {
            if (event.target.value === 'no') {
                document.getElementById('dealer_amount_from_financier_percent').readOnly = true;
                ongoingPromo?.ongoing_promo === '1' ? document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = false : document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = true;
                // document.getElementById('di_amount_from_financier_to_carmudi_tax_percent').readOnly = false;
                setComputationDetails((prev) => ({ ...prev, dealer_amount_from_financier_percent: 0, dealer_amount_from_financier_amount: 0 }));
            }
            else {
                document.getElementById('dealer_amount_from_financier_percent').readOnly = false;
                ongoingPromo?.ongoing_promo === '1' ? document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = false : document.getElementById('di_amount_from_financier_to_carmudi_percent').readOnly = true;
                // document.getElementById('di_amount_from_financier_to_carmudi_tax_percent').readOnly = false;
            }
            setDiAmountpass({
                [event.target.name]: event.target.id
            });
        } else if (event.target.name === 'advance_amount_paid') {
            event.target.value === 'yes' ? setComputationDetails((prev) => ({ ...prev, advance_amount: computationDetails?.total_fee_by_customer })) : setComputationDetails((prev) => ({ ...prev, advance_amount: 0, paid_through: null }));
            setAdvanceDiPaid({
                [event.target.name]: event.target.id
            });
        } else if (event.target.name === 'vat_input') {
            setVatInput({
                [event.target.name]: event.target.id
            });
        } else if (name === "is_vat_back_involved") {
            setIsVatBackInvolved({ is_vat_back_involved: value });
            setComputationDetails((prev) => {
                let updates = { ...prev, [name]: value };

                if (value === "No") {
                    updates.mode_of_vat_back_received = null;
                    updates.is_wht_deducted = "No";
                    updates.requested_tax_wht_deduction_on_di_percentage = 0;
                } else if (value === "Yes") {
                updates.mode_of_vat_back_received = prev.mode_of_vat_back_received; 
                updates.is_wht_deducted = prev.is_wht_deducted || "No";
                }
                return updates;
            });
        } else if (name === "mode_of_vat_back_received") {
            setComputationDetails((prev) => {
                let updates = { ...prev, [name]: value };

                if (value !== "as_additional_revenue") {
                    updates.is_wht_deducted = "No";
                    updates.requested_tax_wht_deduction_on_di_percentage = 0;
                }
                return updates;
            });
        } else if (name === "is_wht_deducted") {
            setComputationDetails((prev) => ({
                ...prev,
                [name]: value,
                requested_tax_wht_deduction_on_di_percentage: value === "No" ? 0 : prev.requested_tax_wht_deduction_on_di_percentage,
            }));
        }
        if (event.target.value === 'exclusive') {
            document.getElementById('exclusiveper').readOnly = false;
            document.getElementById('inclusiveper').readOnly = true;
        }
        else if (event.target.value === 'inclusive') {
            document.getElementById('inclusiveper').readOnly = false;
            document.getElementById('exclusiveper').readOnly = true;
        }

        if (event.target.name === "adp_type") {
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.name]: event.target.value,
                ...((event.target.value === "Yes" && { surcharge_for_adp: ADVANCE_DEALER_PAID.ADP_SURCHARGE.default, title_transfer_charge: ADVANCE_DEALER_PAID.TITLE_TRANSFER_CHARGE.default,is_if_case:"No",is_if_transfer_to_finsso:null }) || {})
            }));
            event.target.value === "No" && emptyADPFields();
        }
        if (event.target.name === "finsso_transfer") {
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.name]: event.target.value,
                ...((event.target.value === "Yes" && { surcharge_for_adp: 0 }) || {})
            }));
        }

        if (['title_transfer_type', 'orcr_docs_verification_done'].includes(event.target.name)) {
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.name]: event.target.value
            }));
        }
        if(event.target.name === "is_vat_back_on_mi"){
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.name]: event.target.value
            }));
        }
        if(event.target.name === "wht_on_gross"){
            setComputationDetails(currentValue => ({
                ...currentValue,
                [event.target.name]: event.target.value
            }));
        }
        if(event.target.name === "is_if_case"){
            setComputationDetails(currentValue => ({
                ...currentValue,
                is_if_transfer_to_finsso:null,
                [event.target.name]: event.target.value
            }));
            setFinssoInput({});
        }
        if(event.target.name === "is_if_transfer_to_finsso"){
            setComputationDetails(currentValue => ({
                ...currentValue,
                total_amount_sent_to_finsso:0,
                from_main_dealer:0,
                from_split_payments:0,
                [event.target.name]: event.target.value
            }));
            setFinssoInput({
                [event.target.name]: event.target.id
            });
        }
    };


    useEffect(() => {
        let dealer_incentive_net_of_tax_to_be_paid = +(computationDetails?.["dealer_incentive_net_of_tax"] - (computationDetails?.[`loan_value`] * (computationDetails?.["surcharge_for_adp"] / 100)) - computationDetails?.["title_transfer_charge"]) || 0;
        updateComputationFields("dealer_incentive_net_of_tax_to_be_paid", dealer_incentive_net_of_tax_to_be_paid);
    }, [computationDetails?.surcharge_for_adp, computationDetails?.title_transfer_charge, computationDetails?.dealer_incentive_net_of_tax, computationDetails?.loan_value]);

    useEffect(() => {
        let computationDetailUpdate = computationDetails;
        if (computationDetails?.final_loan_value === 0) {
            computationDetailUpdate.adp_type = "No";
        }
        else {
            if (computationDetailUpdate?.adp_parameter === "Percentage") {
                computationDetailUpdate.adp_percentage_value = computationDetailUpdate.adp_percentage_value || ADVANCE_DEALER_PAID.ADP_PERCENTAGE_RANGE.default;
                computationDetailUpdate = setAdvanceLoanValueToBePaid(computationDetailUpdate);
                setAdpPerValue(true);
            }
            if (computationDetailUpdate?.adp_parameter === "Absolute") {
                computationDetailUpdate.advance_loan_value_to_be_paid = +(computationDetailUpdate.advance_loan_value_to_be_paid || 0);
                adpFieldEnableDisable("advance_loan_value_to_be_paid", false);
                setAdpPerValue(false);
            }
            computationDetailUpdate.remaining_loan_value_to_be_paid = +calculateADPRemainingAmount(computationDetailUpdate.advance_loan_value_to_be_paid);
        }
        setComputationDetails(currentValue => ({
            ...currentValue,
            ...computationDetailUpdate
        }));
        computationDetailUpdate?.adp_type === "No" && emptyADPFields();
    }, [computationDetails?.final_loan_value, computationDetails?.adp_parameter]);

    const cappedAdvanceLoanValue = (value) => {
        return (value > MAX_ADVANCE_LOAN_VALUE && MAX_ADVANCE_LOAN_VALUE) || value;
    };

    const emptyADPFields = () => {
        setComputationDetails(currentValue => ({
            ...currentValue,
            adp_parameter: null,
            advance_loan_value_to_be_paid: 0,
            remaining_loan_value_to_be_paid: 0,
            surcharge_for_adp: 0,
            title_transfer_charge: 0,
            dealer_incentive_net_of_tax_to_be_paid: 0,
        }));
    };

    const handlePatternFormatChange = (data, field_name) => {
        if (field_name && data.value !== undefined) {
            setComputationDetails(currentValue => ({
                ...currentValue,
                [field_name]: parseFloat(data.value) || 0
            }));
        }
    };

    const handleSelectChange = (data, field_name) => {
        if (data && field_name) {
            let computationMasterObj = computationMasterDetails?.find(master => master.tenure_in_month === parseInt(data.value) && master.chattel_fee === computationDetails?.chattel_percentage);
            field_name === 'tenure_in_months' ? setComputationDetails(currentValue => ({
                ...currentValue,
                di_amount_from_financier_to_carmudi_percent: computationMasterObj?.di_payment_from_financier_gross || 0,
                di_amount_from_financier_to_carmudi_tax_percent: computationMasterObj?.di_payment_from_financier_tax || 0,
                dealer_incentive_percentage_gross: computationMasterObj?.dealer_incentive_gross || 0,
                carmudi_top_up_percentage: computationMasterObj?.carmudi_top_up_gross || 0,
                [field_name]: parseInt(data.value) || 0
            })) : setComputationDetails(currentValue => ({
                ...currentValue,
                [field_name]: field_name === "paid_through" ? data.value : (parseInt(data.value) || 0)
            }));
        }
    };

    const updateComputationFields = (key, value) => {
        setComputationDetails(currentValue => ({
            ...currentValue,
            [key]: value
        }));
    };
    const setAdvanceLoanValueToBePaid = (computationDetailUpdate) => {
        const advanceLoanValue = calculatePercentageValue(computationDetailUpdate.final_loan_value, computationDetailUpdate?.adp_percentage_value);
        computationDetailUpdate.advance_loan_value_to_be_paid = +cappedAdvanceLoanValue(advanceLoanValue);
        computationDetailUpdate.remaining_loan_value_to_be_paid = +calculateADPRemainingAmount(computationDetailUpdate.advance_loan_value_to_be_paid);
        adpFieldEnableDisable("advance_loan_value_to_be_paid", true);
        return computationDetailUpdate;
        
    };
    const handleADPChange = (data, field_name) => {
        if (data && field_name) {
            let computationDetailUpdate = computationDetails;
            computationDetailUpdate[field_name] = data?.value || (data?.target?.value?.charAt(data?.target?.value?.length - 1) === "." ? data?.target?.value : parseFloat(data?.target?.value)) || 0;
            if (field_name === "adp_percentage_value") {
                computationDetailUpdate = setAdvanceLoanValueToBePaid(computationDetailUpdate);
            }
            if (field_name === "advance_loan_value_to_be_paid") {
                computationDetailUpdate.advance_loan_value_to_be_paid = +cappedAdvanceLoanValue(computationDetailUpdate.advance_loan_value_to_be_paid);
                computationDetailUpdate.remaining_loan_value_to_be_paid = +calculateADPRemainingAmount(computationDetailUpdate.advance_loan_value_to_be_paid);
            }
            setComputationDetails(currentValue => ({
                ...currentValue,
                ...computationDetailUpdate
            }));
        }
    };

    const calculateADPRemainingAmount = (advance_loan_value_to_be_paid = 0) => {
        return (computationDetails["final_loan_value"] && (computationDetails["final_loan_value"] - advance_loan_value_to_be_paid)) || 0;
    };

    const adpFieldEnableDisable = (fieldName, action) => {
        ADVANCE_DEALER_PAYOUT.find(field => field.name === fieldName).readOnly = action;
    };

    const getModel = (make_id) => {
        if (make_id) {
            let options = masterdata ? { ...masterdata.masterdatammvcomp } : {};
            options["model"] = make_id !== 0 ? options.model?.map(model => ({ value: model.id, label: model.m, mk_id: model.mk_id })).filter(md => md.mk_id === make_id) : [{ value: 0, label: 'Other' }];
            let all_options = { ...allOptions };
            all_options["model"] = options["model"];
            all_options["variant"] = [];
            setAllOptions(all_options);
        }
    };

    const getVersion = (model_id) => {
        if (model_id) {
            let options = masterdata ? { ...masterdata.masterdatammvcomp } : {};
            options["variant"] = model_id !== 0 ? options.version?.map(version => ({ value: version.vn_id, label: version.vn, mk_id: version.mk_id, md_id: version.md_id })).filter(v => v.md_id === model_id) : [{ value: 0, label: 'Other' }];
            let all_options = { ...allOptions };
            all_options["variant"] = options["variant"];
            setAllOptions(all_options);
        }
    };

    const getMake = (vehicle_type) => {
        if (vehicle_type && Number(vehicle_type) !== 6) {
            get_master_data(vehicle_type);
        }
        else {
            setAllOptions({ ...allOptions, brand: [{ value: 0, label: 'Other' }] });
        }
    };

    useEffect(() => {
        const vehicle_type = masterdata?.masterdatammvcomp?.vehicle_usage?.find(el => +el?.id === +computationDetails?.vehicle_usage)?.vehicle_type || [];
        setAllOptions(prev => ({ ...prev, vehicle_type }));
    }, [computationDetails?.vehicle_usage, masterdata]);

    const handleMakeChange = (sname, ovalue) => {
        computationDetails[sname] = ovalue.value;
        if (sname === 'make_id') {
            getModel(ovalue.value);
            computationDetails['model_id'] = null;
            computationDetails['variant_id'] = null;
        }
        else if (sname === 'model_id') { getVersion(ovalue.value); computationDetails['variant_id'] = null; }

        else if (sname === 'vehicle_type') {
            getMake(ovalue.value);
            computationDetails[sname] = parseInt(ovalue.value);
            computationDetails['model_id'] = null;
            computationDetails['make_id'] = null;
            computationDetails['variant_id'] = null;
        }
        else if (sname === 'vehicle_usage') {
            setAllOptions(prev => ({ ...prev, vehicle_type: ovalue?.vehicle_type || [] }));
            computationDetails['vehicle_type'] = null;
            computationDetails[sname] = parseInt(ovalue.value);
            computationDetails['model_id'] = null;
            computationDetails['make_id'] = null;
            computationDetails['variant_id'] = null;
        }
        setComputationDetails({ ...computationDetails });
    };

    const handleComputationSubmit = () => {
        if (selectedTab === 'first') {
            setSelectedTab('second');
        } else if (['computation_generated', 'computation_regenerated'].includes(props.current_page)) {
            const decimal_limit = computationValueLength(financierId);
            const variables = { leadComputationDetailsInput: { ...{ lead_id: parseInt(lead_id) }, ...computationDetails, ...ongoingPromo, ...vatInput, ...loanAmountPass, ...advanceDiPaid, ...diAmountPass, ...{ status: "1" } } };
            
            variables.leadComputationDetailsInput['advance_loan_value_to_be_paid'] = +variables?.leadComputationDetailsInput?.advance_loan_value_to_be_paid || 0;
            variables.leadComputationDetailsInput['remaining_loan_value_to_be_paid'] = +variables?.leadComputationDetailsInput?.remaining_loan_value_to_be_paid || 0;
            variables.leadComputationDetailsInput['dealer_incentive_net_of_tax_to_be_paid'] = +variables?.leadComputationDetailsInput?.dealer_incentive_net_of_tax_to_be_paid || 0;
            variables.leadComputationDetailsInput['title_transfer_charge'] = +variables?.leadComputationDetailsInput?.title_transfer_charge || 0;
            variables.leadComputationDetailsInput['surcharge_for_adp'] = +variables?.leadComputationDetailsInput?.surcharge_for_adp || 0;
            variables.leadComputationDetailsInput['adp_percentage_value'] = +variables?.leadComputationDetailsInput?.adp_percentage_value || 0;
            variables.leadComputationDetailsInput['action_type'] = props.current_page;
            if (['computation_regenerated'].includes(props.current_page)) variables.leadComputationDetailsInput['reset_main_tranches'] = isMainDealerEditAllowed || false;
            ["final_loan_value", "dealer_incentive_net_of_tax", "payment_to_dealer"].map(key => {
                variables.leadComputationDetailsInput[key] = +ROUNDOFF_TO_MAX_LIMIT(`${variables.leadComputationDetailsInput?.[key]}`, decimal_limit) || variables.leadComputationDetailsInput?.[key];
                return key;
            });
            if (['computation_generated'].includes(props?.current_page)) {
                variables.leadComputationDetailsInput['docs'] = [...computationDocuments];
            }
            if ( variables.leadComputationDetailsInput["mi_percentage_gross"] === null || variables.leadComputationDetailsInput["mi_percentage_gross"] === 0) { variables.leadComputationDetailsInput["is_vat_back_on_mi"] = null}
            delete variables.leadComputationDetailsInput['__typename'];
            executeGraphQLMutation(SAVE_COMPUTATION_DETAILS, variables, client)
                .then((res) => {
                    if (res?.data.saveLeadComputationDetails.id) {
                        toast.success("success");
                        // setComputationSubmit(false);
                        dispatch(getLoanDetail(lead_id, client));
                        if (props.current_page !== 'computation_regenerated') navigate(`/lead-detail/computation-verified/${params.lead_id}`);
                        if (['computation_generated'].includes(props?.current_page)) setComputationDocuments([]);
                    }
                })
                .catch((err) => {
                    toast.error(err.toString().replace('ApolloError:', ''));
                });
        } else {
            updatestatus(props.current_page);
        }
    };
    let sub_status_to_check = props.current_page === 'computation_generated' ? 8 : props.current_page === 'computation_regenerated' ? SUB_STATUS_CODES.COMPUTATION_REGENERATED : 31;
    const isLeadHistoryExists = lead?.leadDetail?.lead_status_history.some((data) => data.sub_status_id === sub_status_to_check);
    // All the conditions can be combined here for button enable/disable
    const isSubmitDisabled = useMemo(() => {
        if (props.current_page !== 'computation_regenerated' && (lead?.leadDetail?.tab_status?.payment_verification?.is_completed || isLeadHistoryExists)) {
            return true;
        }
        if (props.current_page === 'computation_regenerated') {
            return lead?.leadDetail?.oti_sub_status_id !== SUB_STATUS_CODES.COMPUTATION_RESET;
        }
        return !allowSubmit;
    }, [allowSubmit, lead?.leadDetail, isLeadHistoryExists]);

    const isComputationDisabled = useMemo(() => {
        if (props.current_page !== 'computation_regenerated' && (lead?.leadDetail?.tab_status?.payment_verification?.is_completed || isLeadHistoryExists)) {
            return true;
        }
        if (props.current_page === 'computation_regenerated') {
            return !computationSubmit || lead?.leadDetail?.oti_sub_status_id !== SUB_STATUS_CODES.COMPUTATION_RESET;
        }
        return !computationSubmit;
    }, [computationSubmit, lead?.leadDetail, isLeadHistoryExists]);

    const showModalViewTimeLine = () => {
        setViewTimeLine(true);
        setShowremarkform(true);
        document.body.classList.add("overflow-hidden");
    };

    const hideModalViewTimeLine = () => {
        setViewTimeLine(false);
        document.body.classList.remove("overflow-hidden");
    };

    let computationDetailsForm = useMemo(() => {
        if (computationDetails) {
            let filteredFields = FORM_FIELDS;
            if (computationDetails.make_id !== 0) {
                computationDetails.other_brand = '';
                filteredFields = filteredFields.filter(v => v.id !== "other_brand");
            }
            if (computationDetails.model_id !== 0) {
                computationDetails.other_model = '';
                filteredFields = filteredFields.filter(v => v.id !== "other_model");
            }
            if (computationDetails.variant_id !== 0) {
                computationDetails.other_variant = '';
                filteredFields = filteredFields.filter(v => v.id !== "other_variant");
            }
            console.log("triggered>>>>", filteredFields);
            return filteredFields;
        }
        return FORM_FIELDS;
        
    }, [computationDetails]);
    useEffect(() => {
        setIsVatBackInvolved({
            is_vat_back_involved: computationDetails?.is_vat_back_involved || "No",
        });

        setComputationDetails(prev => ({
            ...prev,
            is_vat_back_involved: computationDetails?.is_vat_back_involved || "No",
            is_wht_deducted: computationDetails?.is_wht_deducted || "No",
            mode_of_vat_back_received: computationDetails?.mode_of_vat_back_received || null,
        }));
    }, []);



    const updatestatus = (action_type) => {
        let variables = {
            updateleadstatus: { page_type: action_type, user_id: UserInfo?.id, lead_id: lead?.leadDetail?.id, remarks: comment }
        };
        executeGraphQLMutation(UPDATE_LEAD_STATUS, variables, client).then((result) => {
            toast.success("Success");
            dispatch(getLoanDetail(lead_id, client));
            action_type === 'computation_resubmit' && navigate(`/lead-detail/computation-generated/${params.lead_id}`);
            setComment("");
            hideConfirmation();
        }).catch(err => {
            hideConfirmation();
            toast.error(err.toString().replace('ApolloError:', ''));
        });
    };

    useEffect(() => {
      if ( !lead?.leadDetail?.lead_computation_details || lead?.leadDetail?.oti_sub_status_id === SUB_STATUS_CODES.COMPUTATION_RESET ||  lead?.leadDetail?.oti_sub_status_id === SUB_STATUS_CODES.COMPUTATION_RESUBMIT) {
        console.log("dhdn")
        setFinancierConfig({ marketplaceIncentive: null, wht: null });
        const fetchIncentiveConfig = async () => {
          try {
            const res = await executeGraphQLQuery(
              MARKET_INCENTIVE(financierId),
              client
            );
            const incentiveData = res?.data?.market_incentives?.[0] || null;
            if (incentiveData) {
              setFinancierConfig({
                marketplaceIncentive:
                  incentiveData.marketplace_incentive_percentage_gross,
                wht: incentiveData.wht_percentage_on_marketplace_incentive,
              });
              setMiEffectiveDate(incentiveData.mi_effective_date || null);
              setMiConfigType("auto")
            }
          } catch (err) {
            throw new Error(err);
          }
        };
        fetchIncentiveConfig();
      }
    }, []);
    useEffect(() => {
        if (lead?.leadDetail?.lead_computation_details) {
            const mi_percentage_gross=financierConfig.marketplaceIncentive;
            const tax_percentage_wht_on_mi=financierConfig.wht
            const mi_effective_date=miEffectiveDate;
            const mi_config_type=miConfigType
            if(lead?.leadDetail?.oti_sub_status_id === SUB_STATUS_CODES.COMPUTATION_RESET ||  lead?.leadDetail?.oti_sub_status_id === SUB_STATUS_CODES.COMPUTATION_RESUBMIT){
                setComputationDetails({ ...lead?.leadDetail?.lead_computation_details, vehicle_type: lead?.leadDetail?.lead_computation_details?.vehicle_type || quoteData?.vehicle_type, other_vehicle_type: lead?.leadDetail?.lead_computation_details?.other_vehicle_type || quoteData?.other_vehicle_type, plate_number: lead?.leadDetail?.lead_details?.plate_number,
                mi_percentage_gross: mi_percentage_gross,
                tax_percentage_wht_on_mi: tax_percentage_wht_on_mi,
                is_vat_back_on_mi:'No',
                mi_effective_date:mi_effective_date,
                mi_config_type:mi_config_type,
             });

            }else{
            setComputationDetails({ ...lead?.leadDetail?.lead_computation_details, vehicle_type: lead?.leadDetail?.lead_computation_details?.vehicle_type || quoteData?.vehicle_type, other_vehicle_type: lead?.leadDetail?.lead_computation_details?.other_vehicle_type || quoteData?.other_vehicle_type, plate_number: lead?.leadDetail?.lead_details?.plate_number
             });
            }
            setOngoingPromo({ 'ongoing_promo': lead?.leadDetail?.lead_computation_details?.ongoing_promo });
            setLoanAmountpass({ 'loan_amount_pass_through': lead?.leadDetail?.lead_computation_details?.loan_amount_pass_through });
            setDiAmountpass({ 'di_amount_pass_through': lead?.leadDetail?.lead_computation_details?.di_amount_pass_through });
            setAdvanceDiPaid({ 'advance_amount_paid': lead?.leadDetail?.lead_computation_details?.advance_amount_paid });
            setVatInput({ 'vat_input': lead?.leadDetail?.lead_computation_details?.vat_input });
        } else {
            let summaryDetails = {
                tenure: quoteData?.tenure_in_month || 0,
                interest_rate: quoteData?.interest_rate || 0,
                installment_amount: quoteData?.installment_amount || 0,
                fmv: quoteData?.car_fmv || 0,
                downpayment: quoteData?.dp_amount || 0,
                chattel_percentage: quoteData?.chattel_percent || 0,
                loan_amount: quoteData?.loan_amount || 0,
                chattel_fee: quoteData?.chattel_fee || 0,
                dst_charges: quoteData?.dst_charges || 0,
                outoftowncharge: quoteData?.out_of_town_charge || 0,
                dealer_incentive_percent: quoteData?.dealer_incentive_percent || 0,
                carmudi_top_up_percent: quoteData?.carmudi_top_up_percent || 0
            };
            let computationMasterObject = computationMasterDetails?.find(data => data.tenure_in_month === summaryDetails.tenure);
            const totalfeebycustomer =
                (summaryDetails.chattel_fee ?? 0) + (summaryDetails.dst_charges ?? 0) + (summaryDetails.outoftowncharge ?? 0);
            const totalPaymentByCustomer =
                (summaryDetails.chattel_fee ?? 0) + (summaryDetails.dst_charges ?? 0) + (summaryDetails.outoftowncharge ?? 0) + (summaryDetails.downpayment ?? 0);
            const dealerIncentiveFromFinancer =
                (summaryDetails.loan_amount ?? 0) * (summaryDetails.dealer_incentive_percent / 100 ?? 0);
            const dealerIncentiveFromCarmudi =
                (summaryDetails.loan_amount ?? 0) * (summaryDetails.carmudi_top_up_percent / 100 ?? 0);
            const totalDealerIncentive = dealerIncentiveFromCarmudi + dealerIncentiveFromFinancer;
            const dealer_incentive_tax_percent = 10;
            const dealer_incentive_financier_net_tax =
                (dealerIncentiveFromFinancer ?? 0) * (1 - dealer_incentive_tax_percent / 100);
            const total_dealer_incentive_net_tax =
                (totalDealerIncentive ?? 0) * (1 - dealer_incentive_tax_percent / 100);
            const total_payment_from_financer =
                (summaryDetails.loan_amount ?? 0) + dealer_incentive_financier_net_tax;
            const total_payment_to_dealer =
                (summaryDetails.loan_amount ?? 0) + (total_dealer_incentive_net_tax ?? 0);
            const dealerIncentiveFromFinancerNetofTax = (dealerIncentiveFromFinancer ?? 0) * (1 - dealer_incentive_tax_percent / 100);
            const di_amount_from_financier_to_carmudi_percent = computationMasterObject?.di_payment_from_financier_gross || 0;
            const di_amount_from_financier_to_carmudi_amount = (di_amount_from_financier_to_carmudi_percent ?? 0) * (summaryDetails.loan_amount ?? 0) / 100;
            const di_amount_from_financier_to_carmudi_tax_percent = computationMasterObject?.di_payment_from_financier_tax || 0;
            const di_amount_from_financier_to_carmudi_net_amount = di_amount_from_financier_to_carmudi_tax_percent && (di_amount_from_financier_to_carmudi_amount ?? 0) * (1 - di_amount_from_financier_to_carmudi_tax_percent / 100);
            const dealer_incentive_percentage_gross = computationMasterObject?.dealer_incentive_gross || 0;
            const dealer_incentive_percentage_net = dealer_incentive_percentage_gross * 0.9 || 0;
            const dealer_incentive_amount = (dealer_incentive_percentage_gross ?? 0) * (summaryDetails.loan_amount ?? 0) / 100;
            const carmudi_top_up_amount = summaryDetails.loan_amount * (summaryDetails.carmudi_top_up_percent / 100) || 0;
            const total_dealer_incentive_percent = summaryDetails.carmudi_top_up_percent + dealer_incentive_percentage_gross || 0;

            const total_dealer_incentive_amount = carmudi_top_up_amount + dealer_incentive_amount || 0;

            const remaining_dealer_incentive_amount = total_dealer_incentive_amount || 0;
            const total_dealer_incentive_net_amount = (remaining_dealer_incentive_amount * 0.9) || 0;
            const mi_percentage_gross=financierConfig.marketplaceIncentive;
            const tax_percentage_wht_on_mi=financierConfig.wht
            const mi_effective_date=miEffectiveDate;
            const mi_config_type=miConfigType
            setComputationDetails({
                plate_number: lead?.leadDetail?.lead_details?.plate_number,
                make_id: lead?.leadDetail?.lead_details?.make_id || 0,
                model_id: lead?.leadDetail?.lead_details?.model_id || 0,
                variant_id: lead?.leadDetail?.lead_details?.variant_id || 0,
                other_brand: lead?.leadDetail?.lead_details?.make_name || '',
                other_model: lead?.leadDetail?.lead_details?.model_name || '',
                other_variant: lead?.leadDetail?.lead_details?.variant_name || '',
                year_of_manufacturing: lead?.leadDetail?.lead_details?.make_year || 0,
                tenure_in_months: summaryDetails.tenure,
                interest_rate: summaryDetails.interest_rate,
                installment: summaryDetails.installment_amount,
                fmv: summaryDetails.fmv,
                down_payment_amount: summaryDetails.downpayment,
                chattel_percentage: summaryDetails.chattel_percentage,
                out_of_town_charges: summaryDetails.outoftowncharge,
                dealer_incentive_percentage: summaryDetails.dealer_incentive_percent,
                dealer_incentive_tax_percentage: dealer_incentive_tax_percent,
                carmudi_top_up_percentage: summaryDetails.carmudi_top_up_percent,
                loan_value: summaryDetails.loan_amount,
                chattel_fee: summaryDetails.chattel_fee,
                dst_charges: summaryDetails.dst_charges,
                total_fee_by_customer: totalfeebycustomer,
                total_payment_by_customer: totalPaymentByCustomer,
                dealer_incentive_from_carmudi: dealerIncentiveFromCarmudi,
                dealer_incentive_from_financier: dealerIncentiveFromFinancer,
                total_dealer_incentive: totalDealerIncentive,
                total_dealer_incentive_net_of_tax: total_dealer_incentive_net_tax,
                total_dealer_payment: total_payment_to_dealer,
                dealer_incentive_financier_net_of_tax: dealerIncentiveFromFinancerNetofTax,
                total_payment_from_financier: total_payment_from_financer,
                vehicle_usage: quoteData?.vehicle_usage,
                vehicle_type: quoteData?.vehicle_type,
                other_vehicle_type: quoteData?.other_vehicle_type,
                loan_amount_paid: summaryDetails.loan_amount,
                di_amount_from_financier_to_carmudi_percent: di_amount_from_financier_to_carmudi_percent || 0,
                di_amount_from_financier_to_carmudi_amount: di_amount_from_financier_to_carmudi_amount || 0,
                di_amount_from_financier_to_carmudi_tax_percent: di_amount_from_financier_to_carmudi_tax_percent || 0,
                di_amount_from_financier_to_carmudi_net_amount: di_amount_from_financier_to_carmudi_net_amount || 0,
                advance_amount: totalfeebycustomer,
                total_payment_from_financier_to_carmudi: di_amount_from_financier_to_carmudi_amount && di_amount_from_financier_to_carmudi_net_amount + summaryDetails.loan_amount,
                dealer_incentive_percentage_gross: dealer_incentive_percentage_gross || 0,
                dealer_incentive_percentage_net: dealer_incentive_percentage_net,
                dealer_incentive_amount: dealer_incentive_amount,
                carmudi_top_up_amount: carmudi_top_up_amount,
                total_dealer_incentive_percent: total_dealer_incentive_percent,
                total_dealer_incentive_amount: total_dealer_incentive_amount,
                remaining_dealer_incentive_amount: remaining_dealer_incentive_amount,
                dealer_incentive_tax_percent: 10,
                total_dealer_incentive_net_amount: total_dealer_incentive_net_amount,
                final_loan_value: summaryDetails.loan_amount,
                dealer_incentive_net_of_tax: total_dealer_incentive_net_amount,
                payment_to_dealer: total_dealer_incentive_net_amount + summaryDetails.loan_amount || 0,
                title_transfer_type: 'No',
                orcr_docs_verification_done: 'No',
                is_vat_back_involved:'No',
                is_wht_deducted:'No',
                mi_percentage_gross: mi_percentage_gross,
                tax_percentage_wht_on_mi: tax_percentage_wht_on_mi,
                is_vat_back_on_mi:'No',
                mi_effective_date:mi_effective_date,
                mi_config_type:mi_config_type,
                wht_on_gross:'Yes',
                finsso_transfer:'No',
                is_if_case:'No'
            });
        }
        
    }, [lead?.leadDetail, computationMasterDetails,financierConfig]);

    useEffect(() => {
        if (computationDetails['dealer_incentive_tax_percentage'] >= 0
            && lead?.leadDetail) {
            let dealer_incentive_financier_net_of_tax, total_dealer_incentive_net_of_tax, total_payment_from_financier, total_dealer_payment;
            dealer_incentive_financier_net_of_tax = computationDetails['dealer_incentive_from_financier'] * (1 - computationDetails['dealer_incentive_tax_percentage'] / 100);
            total_dealer_incentive_net_of_tax = computationDetails['total_dealer_incentive'] * (1 - computationDetails['dealer_incentive_tax_percentage'] / 100);
            total_payment_from_financier = computationDetails['loan_value'] + dealer_incentive_financier_net_of_tax;
            total_dealer_payment = computationDetails['loan_value'] + total_dealer_incentive_net_of_tax;
            setComputationDetails((prev) => ({
                ...prev,
                total_dealer_incentive_net_of_tax,
                total_dealer_payment,
                dealer_incentive_financier_net_of_tax,
                total_payment_from_financier
            }));
        }
        let vehicle_type = computationDetails?.vehicle_type || lead?.leadDetail?.lead_computation_details ? lead?.leadDetail?.lead_computation_details?.vehicle_type : quoteData?.vehicle_type;
        vehicle_type !== 6 ? get_master_data(vehicle_type) : setAllOptions({ ...allOptions, brand: [{ value: 0, label: 'Other' }] });
    }, [lead, computationDetails['dealer_incentive_tax_percentage']]);
    useEffect(() => {
        if ((computationDetails['fmv'] >= 0 || computationDetails['down_payment_amount'] >= 0 || computationDetails['out_of_town_charges'] >= 0 || computationDetails['dst_charges'] >= 0 || computationDetails['chattel_percentage'] >= 0 || computationDetails?.['di_amount_from_financier_to_carmudi_percent'] >= 0 || computationDetails?.['di_amount_from_financier_to_carmudi_tax_percent'] >= 0 || computationDetails?.['dealer_amount_from_financier_percent'] >= 0 || computationDetails?.['dealer_incentive_percentage_gross'] >= 0 || computationDetails?.['carmudi_top_up_percentage'] >= 0 || computationDetails?.['dealer_incentive_tax_percent'] >= 0 || computationDetails?.['requested_tax_wht_deduction_on_di_percentage'] >= 0 || computationDetails?.["mi_percentage_gross"] > 0 || computationDetails?.["tax_percentage_wht_on_mi"] > 0)
            && lead?.leadDetail) {
            let loan_value, chattel_fee, dealer_incentive_from_financier, dealer_incentive_from_carmudi, total_dealer_incentive, total_dealer_incentive_net_of_tax, total_dealer_payment, dealer_incentive_financier_net_of_tax, total_payment_from_financier, total_fee_by_customer, total_payment_by_customer, revenue_including_vat, revenue_excluding_vat, vat_amount, di_amount_from_financier_to_carmudi_amount, di_amount_from_financier_to_carmudi_net_amount, dealer_amount_from_financier_amount, total_payment_from_financier_to_carmudi, dealer_incentive_percentage_net, dealer_incentive_amount, carmudi_top_up_amount, total_dealer_incentive_percent, total_dealer_incentive_amount, remaining_dealer_incentive_amount, total_dealer_incentive_net_amount, final_loan_value, payment_to_dealer, advance_amount,di_amount_from_financier_to_carmudi_tax;
            loan_value = computationDetails['fmv'] - computationDetails['down_payment_amount'];
            chattel_fee = loan_value * (computationDetails['chattel_percentage'] / 100);
            total_fee_by_customer = computationDetails['out_of_town_charges'] + computationDetails['dst_charges'] + chattel_fee ?? 0;
            advance_amount = advanceDiPaid?.['advance_amount_paid'] === 'yes' ? total_fee_by_customer : 0;
            total_payment_by_customer = total_fee_by_customer + computationDetails['down_payment_amount'];
            dealer_incentive_from_financier = loan_value * (computationDetails['dealer_incentive_percentage'] / 100);
            dealer_incentive_from_carmudi = loan_value * (computationDetails['carmudi_top_up_percentage'] / 100);
            total_dealer_incentive = dealer_incentive_from_financier + dealer_incentive_from_carmudi;
            total_dealer_incentive_net_of_tax = total_dealer_incentive * (1 - computationDetails['dealer_incentive_tax_percentage'] / 100);
            total_dealer_payment = loan_value + total_dealer_incentive_net_of_tax;
            dealer_incentive_financier_net_of_tax = dealer_incentive_from_financier * (1 - computationDetails['dealer_incentive_tax_percentage'] / 100);
            total_payment_from_financier = loan_value + dealer_incentive_financier_net_of_tax;
            revenue_including_vat = loan_value * (computationDetails?.['inclusive_per'] / 100) || 0;
            revenue_excluding_vat = loan_value * (computationDetails?.['exclusive_per'] / 100) || 0;
            vat_amount = Number((revenue_including_vat) - (revenue_excluding_vat));
            di_amount_from_financier_to_carmudi_amount = loan_value * (computationDetails?.['di_amount_from_financier_to_carmudi_percent'] / 100) || 0;
            di_amount_from_financier_to_carmudi_tax=(di_amount_from_financier_to_carmudi_amount*computationDetails?.['di_amount_from_financier_to_carmudi_tax_percent'] / 100) || 0;
            if (computationDetails?.["wht_on_gross"] === "Yes") {
                di_amount_from_financier_to_carmudi_tax = (di_amount_from_financier_to_carmudi_amount * computationDetails?.['di_amount_from_financier_to_carmudi_tax_percent'] / 100) || 0;
            } else if (computationDetails?.["wht_on_gross"] === "No") {
                di_amount_from_financier_to_carmudi_tax = ((di_amount_from_financier_to_carmudi_amount / 1.12) * computationDetails?.['di_amount_from_financier_to_carmudi_tax_percent'] / 100) || 0;
            }
            di_amount_from_financier_to_carmudi_net_amount = di_amount_from_financier_to_carmudi_amount &&di_amount_from_financier_to_carmudi_amount-di_amount_from_financier_to_carmudi_tax;
            dealer_amount_from_financier_amount = loan_value * (+computationDetails?.['dealer_amount_from_financier_percent'] / 100) || 0;
            total_payment_from_financier_to_carmudi = loanAmountPass?.['loan_amount_pass_through'] === 'yes' ? di_amount_from_financier_to_carmudi_net_amount : di_amount_from_financier_to_carmudi_net_amount + loan_value;

            dealer_incentive_percentage_net = (computationDetails?.['dealer_incentive_percentage_gross'] * 0.9) || 0;
            dealer_incentive_amount = loan_value * (computationDetails?.['dealer_incentive_percentage_gross'] / 100) || 0;

            carmudi_top_up_amount = loan_value * (computationDetails?.['carmudi_top_up_percentage'] / 100) || 0;
            total_dealer_incentive_percent = computationDetails?.['carmudi_top_up_percentage'] + computationDetails?.['dealer_incentive_percentage_gross'] || 0;
            total_dealer_incentive_amount = carmudi_top_up_amount + dealer_incentive_amount || 0;
            remaining_dealer_incentive_amount = total_dealer_incentive_amount;
            if (computationDetails?.["paid_through"] === "dealer_incentive") {
                remaining_dealer_incentive_amount -= (advance_amount / (1 - computationDetails?.['dealer_incentive_tax_percent'] / 100));
            }
            total_dealer_incentive_net_amount = remaining_dealer_incentive_amount * (1 - computationDetails?.['dealer_incentive_tax_percent'] / 100) || 0;

            if (loanAmountPass?.['loan_amount_pass_through'] === 'no') {
                final_loan_value = loan_value;
                if (computationDetails?.["paid_through"] === "loan_proceeds") {
                    final_loan_value -= advance_amount;
                }
            } else {
                final_loan_value = 0;
            }
            payment_to_dealer = total_dealer_incentive_net_amount + final_loan_value;
            let vat_back_percent = 0, vat_back_amount = 0, final_amount_received_from_financer = 0,requested_tax_wht_deduction_on_di_amount=0,final_di_amount_from_financier_to_carmude_net_of_tax=0,tax_wht_deduction_vat_back_percent=0,tax_wht_deduction_vat_back_amount=0,final_vat_back_amount=0;
            if (computationDetails?.is_vat_back_involved === "Yes" && (computationDetails?.mode_of_vat_back_received === "along_with_di_payment" || computationDetails?.mode_of_vat_back_received === "as_additional_revenue")) {
                vat_back_percent = computationDetails?.di_amount_from_financier_to_carmudi_percent ? computationDetails.di_amount_from_financier_to_carmudi_percent * 0.12 : 0;
                console.log(computationDetails.loan_value);
                console.log(loan_value)
                vat_back_amount = loan_value ? (loan_value * vat_back_percent) / 100 : 0;
                if (computationDetails?.mode_of_vat_back_received === "along_with_di_payment") {
                    final_amount_received_from_financer = (di_amount_from_financier_to_carmudi_net_amount || 0) + vat_back_amount;
                    computationDetails.is_wht_deducted = "No";
                }
            }

                let requested_tax_wht_deduction_on_di_percentage = computationDetails?.requested_tax_wht_deduction_on_di_percentage || 0;
                let diGross = di_amount_from_financier_to_carmudi_amount || 0;
                let diTaxPercent = computationDetails?.di_amount_from_financier_to_carmudi_tax_percent || 0;
                if ( computationDetails?.is_vat_back_involved === "Yes" && computationDetails?.mode_of_vat_back_received === "as_additional_revenue" && requested_tax_wht_deduction_on_di_percentage > 0) {
                    requested_tax_wht_deduction_on_di_amount = (requested_tax_wht_deduction_on_di_percentage / 100) * diGross;
                    final_di_amount_from_financier_to_carmude_net_of_tax = diGross - requested_tax_wht_deduction_on_di_amount;
                    tax_wht_deduction_vat_back_percent = Math.max(diTaxPercent - requested_tax_wht_deduction_on_di_percentage, 0);
                    tax_wht_deduction_vat_back_amount = (tax_wht_deduction_vat_back_percent / 100) * diGross;
                    final_vat_back_amount = (vat_back_amount || 0) - tax_wht_deduction_vat_back_amount;
                } else {
                    requested_tax_wht_deduction_on_di_percentage = 0;
                }

           let mi_amount_gross = 0, tax_amount_wht_on_mi = 0, mi_amount_net = 0, vat_back_on_mi_amount = 0, final_mi = 0,mi_config_type="";
            if (computationDetails?.["mi_percentage_gross"] != null && computationDetails?.["tax_percentage_wht_on_mi"] != null) {
                mi_amount_gross = loan_value * (computationDetails?.["mi_percentage_gross"] / 100) || 0;
                tax_amount_wht_on_mi = mi_amount_gross * (computationDetails?.["tax_percentage_wht_on_mi"] / 100) || 0;
                mi_amount_net = mi_amount_gross - tax_amount_wht_on_mi || 0;
                vat_back_on_mi_amount = computationDetails?.is_vat_back_on_mi?.toLowerCase() === "yes" ? mi_amount_gross * 0.12 : 0;
                final_mi = mi_amount_net + vat_back_on_mi_amount;
                mi_config_type=(financierConfig.marketplaceIncentive===computationDetails?.["mi_percentage_gross"] && financierConfig.wht===computationDetails?.["tax_percentage_wht_on_mi"]) ? "auto" : "manual";
            }
            setComputationDetails((prev) => ({
                ...prev,
                loan_value,
                chattel_fee,
                total_fee_by_customer,
                total_payment_by_customer,
                dealer_incentive_from_financier,
                dealer_incentive_from_carmudi,
                total_dealer_incentive,
                total_dealer_incentive_net_of_tax,
                total_dealer_payment,
                dealer_incentive_financier_net_of_tax,
                total_payment_from_financier,
                revenue_including_vat,
                revenue_excluding_vat,
                vat_amount,
                loan_amount_paid: loanAmountPass?.['loan_amount_pass_through'] === 'yes' ? loan_value : 0,
                di_amount_from_financier_to_carmudi_amount,
                di_amount_from_financier_to_carmudi_net_amount,
                dealer_amount_from_financier_amount,
                advance_amount,
                total_payment_from_financier_to_carmudi,
                dealer_incentive_percentage_net,
                dealer_incentive_amount,
                carmudi_top_up_amount,
                total_dealer_incentive_percent,
                total_dealer_incentive_amount,
                remaining_dealer_incentive_amount,
                total_dealer_incentive_net_amount,
                final_loan_value,
                payment_to_dealer,
                dealer_incentive_net_of_tax: total_dealer_incentive_net_amount,
                vat_back_percent,
                vat_back_amount,
                final_amount_received_from_financer,
                requested_tax_wht_deduction_on_di_percentage,
                requested_tax_wht_deduction_on_di_amount,
                final_di_amount_from_financier_to_carmude_net_of_tax,
                tax_wht_deduction_vat_back_percent,
                tax_wht_deduction_vat_back_amount,
                final_vat_back_amount,
                di_amount_from_financier_to_carmudi_tax,
                mi_amount_gross,
                tax_amount_wht_on_mi,
                mi_amount_net,
                final_mi,
                vat_back_on_mi_amount,
                mi_config_type
            }));
        }
    }, [lead, computationDetails['fmv'], computationDetails['down_payment_amount'], computationDetails['out_of_town_charges'], computationDetails['dst_charges'], computationDetails['chattel_percentage'], computationDetails?.['di_amount_from_financier_to_carmudi_percent'], computationDetails?.['di_amount_from_financier_to_carmudi_tax_percent'], computationDetails?.['dealer_amount_from_financier_percent'], computationDetails?.['dealer_incentive_percentage_gross'], computationDetails?.['carmudi_top_up_percentage'], computationDetails?.['dealer_incentive_tax_percent'], computationDetails?.["paid_through"],computationDetails?.["requested_tax_wht_deduction_on_di_percentage"],computationDetails?.["mode_of_vat_back_received"] ,computationDetails?.["is_vat_back_involved"],advanceDiPaid, loanAmountPass,computationDetails?.["mi_percentage_gross"],computationDetails?.["tax_percentage_wht_on_mi"],computationDetails?.["is_vat_back_on_mi"],computationDetails?.["wht_on_gross"]]);
    useEffect(() => {
        if (computationDetails['exclusive_per'] && lead?.leadDetail && !isLeadHistoryExists) {
            let inclusive_per, revenue_excluding_vat, revenue_including_vat, vat_amount;
            inclusive_per = ((computationDetails?.exclusive_per >= 0 ? computationDetails?.exclusive_per : 0) * 1.12) || 0;
            revenue_including_vat = computationDetails['loan_value'] * (inclusive_per / 100);
            revenue_excluding_vat = computationDetails['loan_value'] * ((computationDetails?.exclusive_per >= 0 ? computationDetails?.exclusive_per : 0) / 100);
            vat_amount = Number((revenue_including_vat) - (revenue_excluding_vat));
            setComputationDetails((prev) => ({
                ...prev,
                inclusive_per,
                revenue_excluding_vat,
                revenue_including_vat,
                vat_amount
            }));
        }
    }, [lead, computationDetails?.exclusive_per, isLeadHistoryExists]);

    useEffect(() => {
        if (computationDetails['inclusive_per'] && lead?.leadDetail && !isLeadHistoryExists) {
            let exclusive_per, revenue_excluding_vat, revenue_including_vat, vat_amount;
            exclusive_per = (computationDetails?.inclusive_per >= 0 ? computationDetails?.inclusive_per : 0) / 1.12;
            revenue_including_vat = computationDetails['loan_value'] * ((computationDetails?.inclusive_per >= 0 ? computationDetails?.inclusive_per : 0) / 100);
            revenue_excluding_vat = computationDetails['loan_value'] * (exclusive_per / 100);
            vat_amount = Number((revenue_including_vat) - (revenue_excluding_vat));
            setComputationDetails((prev) => ({
                ...prev,
                exclusive_per,
                revenue_excluding_vat,
                revenue_including_vat,
                vat_amount
            }));
        }
    }, [lead, computationDetails?.inclusive_per, isLeadHistoryExists]);
    useEffect(() => {
        const fetchData = async () => {
            let vehicle_type = computationDetails?.vehicle_type || lead?.leadDetail?.lead_computation_details ? lead?.leadDetail?.lead_computation_details?.vehicle_type : quoteData?.vehicle_type;
            get_master_data(vehicle_type);
            if (masterdata) await getMasterDataOptions();
        };
        fetchData();
    }, [masterdata, lead]);

    useEffect(() => {
        if (!lead?.leadDetail?.lead_computation_details) {
            executeGraphQLQuery(COMPUTATION_MASTER_DATA(financierId), client).then(res => {
                if (res?.data?.computationMasterDetails) {
                    setComputationMasterDetails(res?.data?.computationMasterDetails);
                }
            }).catch(err => {
                toast.error("Something went wrong!");
            });
        }
    }, []);
    useEffect(() => {
        if (IsVatBackInvolved?.is_vat_back_involved === "Yes") {
            if (!computationDetails?.mode_of_vat_back_received) {
                setIsVatBackRadiosFilled(false);
                return;
            }
            if (computationDetails?.mode_of_vat_back_received === "as_additional_revenue") {
                if (!computationDetails?.is_wht_deducted) {
                    setIsVatBackRadiosFilled(false);
                    return;
                }
            }
        }
        setIsVatBackRadiosFilled(true);
    }, [IsVatBackInvolved,computationDetails['mode_of_vat_back_received'],computationDetails['is_wht_deducted']]);
    const computationDocs = useMemo(() => {
        const docs = lead?.leadDetail?.leaddocs?.reduce((result, doc) => {
            if (doc?.doc_id === 169) {
                result?.push(doc?.doc_path);
            }
            return result;
        }, []);
        return [...docs, ...computationDocuments];
    }, [lead?.leadDetail?.leaddocs, computationDocuments]);
    const get_master_data = (vehicle_type) => {
        if (!vehicle_type || vehicle_type === 0) return;
        let category_id = 1;
        if (TRUCK_IDS.includes(Number(vehicle_type))) {
            category_id = 3;
        }
        if (Number(vehicleType) !== category_id) {
            dispatch(getMasterDataMMVComputation(client, vehicle_type));
        }
        setVehicleType(category_id);
        getMasterDataOptions();
    };
    let allfieldsReadonly = props.current_page === 'computation_regenerated' ? false : props.current_page === 'computation_generated' && (!UserInfo?.role_id?.includes(1) || lead?.leadDetail?.oti_sub_status_id === 32) ? lead?.leadDetail?.lead_computation_details && accessCondition : lead?.leadDetail?.lead_computation_details || false;
    
    let isComputationRadioMarked = (lead?.leadDetail?.lead_computation_details || (Object.keys(ongoingPromo).length && Object.keys(loanAmountPass).length && Object.keys(diAmountPass).length && Object.keys(advanceDiPaid).length && Object.keys(vatInput).length) && Object.keys(IsVatBackInvolved).length && (computationDetails?.is_if_case === "No" || Object.keys(FinssoInput).length)) && isVatBackRadiosFilled ? true : false;
    const sectionInfo = { section: "Computation", sub_section: "" };
    let latestResubmitRemarks = lead?.leadDetail?.lead_status_history?.filter(data => data.sub_status_id === 32)?.sort((a, b) => b.id - a.id);
    
    const isMainDealerEditAllowed = useMemo(() => {
        return !lead?.leadDetail?.split_payment?.some(item => [PAYMENT_TYPES.MAIN_DEALER, PAYMENT_TYPES.ON_HOLD_DEALER]?.includes(item?.payment_type) && [TRANCHE_STATUS.requested, TRANCHE_STATUS.paid]?.includes(item?.tranche_status));
    }, [lead?.leadDetail?.split_payment]);

    const dealerIncentiveSelectAllowed = useMemo(() => {
        return lead?.leadDetail?.split_payment?.some(item => [PAYMENT_TYPES.MAIN_DEALER, PAYMENT_TYPES.ON_HOLD_DEALER]?.includes(item?.payment_type) && [TRANCHE_STATUS.requested, TRANCHE_STATUS.paid]?.includes(item?.tranche_status)) && ((lead?.leadDetail?.lead_computation_details?.advance_amount_paid === "yes" && lead?.leadDetail?.lead_computation_details?.paid_through === "dealer_incentive") || lead?.leadDetail?.lead_computation_details?.advance_amount_paid === "no");
    }, [lead?.leadDetail?.split_payment, lead?.leadDetail?.lead_computation_details?.advance_amount_paid, lead?.leadDetail?.lead_computation_details?.paid_through]);
    const isRegeneratedFieldActive = (field_name) => {
        if (props.current_page !== 'computation_regenerated') return false;
        if (props.current_page === 'computation_regenerated' && ![SUB_STATUS_CODES.COMPUTATION_RESET].includes(lead?.leadDetail?.oti_sub_status_id)) return true;
        let isDisable = isRegeneratedFieldNeedToActive(field_name);
        if (isDisable && isMainDealerEditAllowed && ["advance_amount_paid", "paid_through"].includes(field_name)) {
            isDisable = isRegeneratedMainDealerFieldsNeedToActive(field_name);
        } else if (isDisable && dealerIncentiveSelectAllowed && ["advance_amount_paid", "paid_through"].includes(field_name)) {
            isDisable = isRegeneratedMainDealerFieldsNeedToActive(field_name);
        }
        return isDisable;
    };
    const isFinssoAccountSelected = () => computationDetails?.["finsso_transfer"] === "Yes";



    const handleFileChange = async (event, max_upload = 5) => {
        let selectedImage = event?.target?.files?.[0]?.name || "";
        let publicUrl = '', doc_path = '';
        if (!selectedImage) {
            toast.error("Please upload an image.");
            return;
        }
    
        const lead_doc_count = computationDocs?.length || 0;
        if (lead_doc_count >= max_upload) {
            toast.error(`Max ${max_upload} documents are allowed!`);
            return;
        }
        const formData = new FormData();
        formData.append('upload_type', UPLOAD_TYPE);
        formData.append('lead_id', lead_id);
        formData.append('images', event.target.files[0]);
        props?.setIsLoading(true);
        try {
            publicUrl = await GeneralService.uploadFilesToS3(formData, { 'Content-Type': 'multipart/form-data' });
            doc_path = publicUrl?.data?.data?.[0]?.file_url || '';
        } catch (error) {
            console.error('Error uploading file:', error);
        }
        setComputationDocuments([...computationDocuments, doc_path]);
        props?.setIsLoading(false);
    };

    const propsToPass = {
        computationDetails,
        allfieldsReadonly,
        financierId,
        lead,
        advanceDiPaid,
        dealerIncentiveSelectAllowed,
        allOptions,
        adpPerValue,
        computationDetailsForm,
        
        // Methods
        handlePatternFormatChange,
        handleMakeChange,
        handleInputChange,
        isRegeneratedFieldActive,
        handleRadioChange,
        handleSelectChange,
        handleADPChange,
        isFinssoAccountSelected
    };
    

    return (
        <div className="image-form-outer">
            <div className="image-tab-panel">
                <DocumentGallery documentCategoryList={documentCategoryList} />
            </div>
            <div className="form-tab-right-panel ">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>Computation</h2>
                        <div className="inline-container">
                            <h2>{props.name}</h2>
                            {props.current_page === 'computation_verified' &&
                                <button type="submit" className="resubmit-btn" onClick={showConfirmation} disabled={isLeadHistoryExists || getContext.markAsFreezed || accessCondition}>
                                    Resubmit <img alt= "" src={resubmitIcn} className="resubmit-icn" />
                                </button>}
                        </div>
                        <div className="doument-gallery-tabs">
                            <Tab.Container id="left-tabs-example" activeKey={selectedTab} defaultActiveKey="first" onSelect={(e) => setSelectedTab(e)}>
                                <Nav variant="pills" className="flex-column">
                                    <div className="tab-list">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">Basic Details</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item >
                                            <Nav.Link disabled={lead?.leadDetail?.lead_computation_details ? false : (isSubmitDisabled)} eventKey="second">Computation</Nav.Link>
                                        </Nav.Item>
                                    </div>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Formsy
                                            className="lead-form-filed"
                                            autoComplete="off"
                                            onValid={() => setAllowSubmit(true)}
                                            onInvalid={() => setAllowSubmit(false)}
                                            onValidSubmit={() => handleComputationSubmit()}
                                        >
                                            <BasicDetails {...propsToPass} />
                                            <div className="btn-save-remarks">
                                                {(isSubmitDisabled || getContext.markAsFreezed || accessCondition) ? <span className="span-disabled">Next</span> :
                                                    <button type="submit" className="btn-primary" disabled={isSubmitDisabled || getContext.markAsFreezed || accessCondition}>
                                                        Next
                                                    </button>
                                                }
                                                <button type="button" className="btn-line" onClick={showModalViewTimeLine}>Remarks
                                                    <span className="m-xs-l">({remarksHistory?.length || 0})</span>
                                                </button>
                                            </div>
                                        </Formsy>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <Formsy
                                            className="lead-form-filed"
                                            autoComplete="off"
                                            onValid={() => setComputationSubmit(true)}
                                            onInvalid={() => setComputationSubmit(false)}
                                            onValidSubmit={handleComputationSubmit}
                                        >
                                            <div className='right-panel-scroll'>
                                                <div className="row">
                                                    {latestResubmitRemarks[0]?.remarks && [SUB_STATUS_CODES.COMPUTATION_GENERATED, SUB_STATUS_CODES.COMPUTATION_RESUBMIT].includes(lead?.leadDetail?.oti_sub_status_id) &&
                                                        <section>
                                                            <div className='comp-cmnt-heading'>Comments</div>
                                                            <div className='comp-cmnt'>{latestResubmitRemarks[0]?.remarks}</div>
                                                        </section>
                                                    }
                                                    <ComputationDetails {...propsToPass} />
                                                    <PassThroughDetails {...propsToPass} />
                                                    <PaymentFromFinancierDetails {...propsToPass} />
                                                    <CarmudiPaymentToDealerDetails {...propsToPass} />
                                                    <FinalLoanDetails {...propsToPass} />
                                                    <AdvanceDealerPayout {...propsToPass} />
                                                    <IfSettlementBox {...propsToPass} />
                                                    <ExtraDetails {...propsToPass} />
                                                </div>
                                            </div>
                                            <UploadDocuments
                                                computationDocs={computationDocs}
                                                allfieldsReadonly={allfieldsReadonly}
                                                handleFileChange={handleFileChange}
                                                current_page={props?.current_page}
                                            />                                            
                                            <div className="btn-save-remarks p-lg-t">
                                                {(isComputationDisabled || !isComputationRadioMarked || accessCondition) ? <span className="span-disabled">{props.current_page === 'computation_generated' ? 'Save' : 'Save & Next'}</span> :
                                                    <button type="submit" className="btn-primary" disabled={isComputationDisabled || !isComputationRadioMarked || accessCondition}>
                                                        {props.current_page === 'computation_generated' ? 'Save' : 'Save & Next'}
                                                    </button>
                                                }
                                                <button type="button" className="btn-line" onClick={showModalViewTimeLine}>Remarks
                                                    <span className="m-xs-l">({remarksHistory?.length || 0})</span>
                                                </button>
                                            </div>
                                        </Formsy>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
            
                </div>
            </div>
            <div className="view-timeline-popup">
                <Modal show={ViewTimeLine} handleClose={hideModalViewTimeLine} >
                    <div className="modal-header">
                        <h2>Remark History</h2>
                    </div>
                    <LeadRemarkHistory showremarkform={showremarkform} markAsFreezed={getContext.markAsFreezed} accessCondition={accessCondition} sectionInfo={sectionInfo} />
                </Modal>
                <Modal show={confirmationModal} handleClose={hideConfirmation} >
                    <div className="modal-header">
                        <h2 style={{ "padding-bottom": "0px" }}>Additional Remarks for re-submisison</h2>
                        <div style={{ "padding-bottom": "20px" }}>For holding the <span style={{ "font-weight": "600" }}>Financier Computation Details</span></div>
                    </div>
                    <div className="modal-body" >
                        <div className="custom-control custom-checkbox">
                            <div className="material">
                                <textarea
                                    name="remarks"
                                    id="remarks"
                                    placeholder="Comments/Reason"
                                    className="form-input"
                                    rows="3"
                                    onChange={(e) => setComment(e.target.value)}
                                    value={comment}
                                >
                                </textarea>
                            </div>
                            <button className="btn-primary" onClick={() => updatestatus('computation_resubmit')} disabled={!comment.length || props.markAsFreezed || accessCondition}>Submit</button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};
export default Computation;